export enum SmokerStatusEnum {
    NoneAtAll = 0,
    YesOccasionally = 1,
    YesRegularly = 2,
}
